import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useCart } from "../context/cartContext";
import Cookies from "js-cookie";
import foto from "../images/carta.png";
import { useWishlist } from "../context/wishlistContext";

const ShoppingCart = () => {
  const {
    cartItems,
    removeFromCart,
    increaseQuantity,
    decreaseQuantity,
    calculateTotal,
  } = useCart();

  const navigate = useNavigate();
  const { handleAddToWishlist } = useWishlist();

  // State to store the message if stock limit is reached
  const [stockMessage, setStockMessage] = useState({});

  useEffect(() => {
    console.log("Cart items in ShoppingCart:", cartItems);
    const anonymousId = Cookies.get("anonymousId");
    console.log("Anonymous ID in ShoppingCart:", anonymousId);
  }, [cartItems]);

  const handleIncrement = (item) => {
    if (item.quantity < item.stock) {
      increaseQuantity(item.id);
      setStockMessage((prevState) => ({
        ...prevState,
        [item.id]: "",
      }));
    } else {
      setStockMessage((prevState) => ({
        ...prevState,
        [item.id]: `You can't order more than ${item.stock} units.`,
      }));
    }
  };

  const handleDecrement = (id) => {
    const item = cartItems.find((item) => item.id === id);
    if (item && item.quantity > 1) {
      decreaseQuantity(id);
      setStockMessage((prevState) => ({
        ...prevState,
        [id]: "",
      }));
    } else {
      setStockMessage((prevState) => {
        const updatedMessages = { ...prevState };
        delete updatedMessages[id];
        return updatedMessages;
      });
    }
  };
  
  const handleRemove = (id) => {
    removeFromCart(id);
    setStockMessage((prevState) => ({
      ...prevState,
      [id]: "",
    }));
  };

  const handleCheckout = () => {
    navigate("/checkout");
  };

  // Calculate the subtotal of all cart items
  const total = Number(calculateTotal());

  // Wishlist click handler
  const handleWishlistClick = (item) => {
    handleAddToWishlist(item);
  };

  return (
    <>
      <Header />
      <section className="min-h-screen bg-white py-6 antialiased dark:bg-gray-900">
        <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
            Shopping Cart
          </h2>
          <div className="mt-6 flex flex-col lg:flex-row lg:items-start lg:gap-8">
            {/* Cart Items */}
            <div className="w-full lg:w-2/3 lg:overflow-y-auto lg:max-h-[80vh]">
              <div className="space-y-6">
                {cartItems.length === 0 ? (
                  <div className="flex flex-col items-center justify-center min-h-[300px] lg:min-h-[80vh]">
                    <div className="w-full max-w-xs md:max-w-md lg:max-w-lg">
                      <img
                        className="object-cover w-full h-auto"
                        src={foto}
                        alt="Empty Cart"
                      />
                    </div>
                    <p className="text-lg font-medium text-gray-600 dark:text-gray-300 text-center">
                      Your cart is empty.
                    </p>
                    <p className="text-base font-normal text-gray-500 dark:text-gray-400 mt-2 text-center">
                      Looks like you haven't added any items to your cart yet.
                    </p>
                    <button
                      onClick={() => (window.location.href = "/")}
                      className="mt-4 inline-flex items-center justify-center rounded-md bg-blue-600 px-5 py-2.5 text-white font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:bg-blue-500 dark:hover:bg-blue-600"
                    >
                      Continue Shopping
                    </button>
                  </div>
                ) : (
                  cartItems.map((item) => (
                    <div
                      key={item.id}
                      className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800 md:p-6"
                    >
                      <div className="space-y-4 md:flex md:items-center md:justify-between md:gap-6 md:space-y-0">
                        <a
                          href={`/product/${item.id}`}
                          className="shrink-0 md:order-1"
                        >
                          <img
                            className="h-20 w-20"
                            src={item.imageURIs[0]}
                            alt={item.name}
                          />
                        </a>
                        <div className="flex items-center justify-between md:order-3 md:justify-end w-full">
                          <div className="flex items-center space-x-2">
                            <button
                              type="button"
                              onClick={() => handleDecrement(item.id)}
                              className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700"
                            >
                              <i className="fas fa-minus text-gray-900 dark:text-white"></i>
                            </button>
                            <input
                              type="text"
                              value={item.quantity}
                              className="w-10 shrink-0 border-0 bg-transparent text-center text-sm font-medium text-gray-900 focus:outline-none focus:ring-0 dark:text-white"
                              readOnly
                            />
                            <button
                              type="button"
                              onClick={() => handleIncrement(item)}
                              className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700"
                            >
                              <i className="fas fa-plus text-gray-900 dark:text-white"></i>
                            </button>
                          </div>
                          <div className="text-right md:order-4 md:w-32">
                            <p className="text-sm font-bold text-gray-900 dark:text-white">
                              ${(item.final_price * item.quantity).toFixed(2)}
                            </p>
                          </div>
                        </div>
                        <div className="w-full min-w-0 flex-1 space-y-4 md:order-2 md:max-w-md">
                          <a
                            href={`/product/${item.id}`}
                            className="text-base font-medium text-gray-900 hover:underline dark:text-white"
                          >
                            {item.name}
                          </a>
                          <div className="flex items-center gap-4">
                            <button
                              type="button"
                              onClick={() => handleWishlistClick(item)}
                              className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-900 hover:underline dark:text-gray-400 dark:hover:text-white"
                            >
                              <i className="fas fa-heart me-1.5"></i>
                              Add to Wishlist
                            </button>
                            <button
                              type="button"
                              onClick={() => handleRemove(item.id)}
                              className="inline-flex items-center text-sm font-medium text-red-600 hover:underline dark:text-red-500"
                            >
                              <i className="fas fa-times me-1.5"></i>
                              Remove
                            </button>
                          </div>
                        
                        </div>
                      </div>
                      {stockMessage[item.id] && (
                            <div className="flex flex-col md:flex-row md:items-center gap-2 mt-2 text-red-500 md:text-sm lg:text-base">
                              <i className="fas fa-exclamation-circle"></i>
                              <p className="font-medium">
                                {stockMessage[item.id]}
                              </p>
                            </div>
                          )}
                    </div>
                  ))
                )}
              </div>
            </div>
            {/* Cart Summary */}
            {cartItems.length > 0 && (
              <div className="w-full lg:w-1/3 mt-6 lg:mt-0 lg:sticky lg:top-4 lg:self-start">
                <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800 md:p-6">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                    Summary
                  </h3>
                  <div className="mt-6 space-y-4">
                    <div className="flex items-center justify-between">
                      <p className="text-base font-normal text-gray-500 dark:text-gray-400">
                        Subtotal
                      </p>
                      <p className="text-base font-medium text-gray-900 dark:text-white">
                        ${total.toFixed(2)}
                      </p>
                    </div>
                  </div>
                  <div className="mt-6 flex items-center justify-between border-t border-gray-200 pt-4 dark:border-gray-700">
                    <p className="text-base font-medium text-gray-900 dark:text-white">
                      Total
                    </p>
                    <p className="text-lg font-bold text-gray-900 dark:text-white">
                      ${total.toFixed(2)}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={handleCheckout}
                    className="mt-6 w-full rounded-lg bg-blue-600 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:bg-blue-500 dark:hover:bg-blue-600"
                  >
                    Checkout
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ShoppingCart;
